/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parties_HintInputs */

const cs_parties_hint = /** @type {(inputs: Parties_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodávající, kupující, pronajímatelé, nájemníci.`)
};

const en_parties_hint = /** @type {(inputs: Parties_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sellers, buyers, landlords, tenants.`)
};

/**
* | output |
* | --- |
* | "Sellers, buyers, landlords, tenants." |
*
* @param {Parties_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const parties_hint = /** @type {((inputs?: Parties_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parties_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_parties_hint(inputs)
	return cs_parties_hint(inputs)
});